var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f26836;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,29.98c.02,8.28-6.69,15.01-14.98,15.02-8.24,.01-14.99-6.7-15.01-14.94-.03-8.26,6.7-15.03,14.97-15.06,8.26-.03,15.01,6.69,15.03,14.98Zm-20.71,8.98c3.4,2.52,9.65,2.61,13.64-1.77,3.78-4.14,3.27-10.06,1.02-12.89-4.88,4.89-9.78,9.78-14.66,14.66Zm11.48-17.94c-4.03-2.84-10.13-2.07-13.63,1.75-3.73,4.07-3.38,9.9-1.08,12.96,4.9-4.9,9.81-9.81,14.71-14.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage26);
export default __webpack_public_path__ + "static/media/UDS Needs Image-26.fcf3fcf0b7d8efc5e4d9e50df7e40b1b.svg";
export { ForwardRef as ReactComponent };